import { connect } from 'react-redux';
import { redux } from '../api';

import ReportCt from './ReportCt.js';
const { setCurrentSearchInfo } = redux.actions;
const { setApplicationInfo } = redux.actions;
const { nationalDict, IDTypeDict, cardTypeDict } = redux.actions;
const { setCurrentReportTime, setCTUserInfo } = redux.actions;
const mapStateToProps = state => {
  return {
    user: state.api.user.ctInfo,
    // current: state.api.current,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setCurrentSearchInfoData: data => {
      dispatch(setCurrentSearchInfo(data));
    },
    setApplicationData: data => {
      dispatch(setApplicationInfo(data));
    },
    setNationalDict: data => {
      dispatch(nationalDict(data));
    },
    setIDTypeDict: data => {
      dispatch(IDTypeDict(data));
    },
    setCardTypeDict: data => {
      dispatch(cardTypeDict(data));
    },
    setCurrentReportTime: data => {
      dispatch(setCurrentReportTime(data));
    },
    onUserInfoUpdated: user => {
      dispatch(setCTUserInfo(user));
    },
  };
};

const ConnectedReportCT = connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportCt);

export default ConnectedReportCT;
